import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", {
  class: "fs16 fw600 fl monthTitle posAb arial",
  style: {"left":"48px"}
}, null, -1)
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  class: "availableTimePreviewContent availableTimePreviewContentWeekly",
  style: {"min-height":"340px"}
}
const _hoisted_6 = {
  key: 0,
  class: "availableTimeTable arial",
  style: {"width":"96%","margin-left":"4%"}
}
const _hoisted_7 = { style: {"table-layout":"fixed"} }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td")
], -1)
const _hoisted_9 = ["id"]
const _hoisted_10 = {
  class: "timespanTitle fl",
  style: {"width":"4%"}
}
const _hoisted_11 = ["id"]
const _hoisted_12 = {
  key: 0,
  class: "availableTimeTable EventsContent fl",
  style: {"width":"96%"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FlashNotice = _resolveComponent("FlashNotice")!
  const _component_IconRefresh = _resolveComponent("IconRefresh")!
  const _component_WeeklyDetailHeader = _resolveComponent("WeeklyDetailHeader")!
  const _component_DailyLine = _resolveComponent("DailyLine")!
  const _component_CalendarEventModal = _resolveComponent("CalendarEventModal")!
  const _component_CalendarTagDetailModal = _resolveComponent("CalendarTagDetailModal")!
  const _component_CalendarEventDetailModal = _resolveComponent("CalendarEventDetailModal")!
  const _component_AlertModal = _resolveComponent("AlertModal")!
  const _component_ChangeMaxBookingsNumModal = _resolveComponent("ChangeMaxBookingsNumModal")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_ctx.cm.astag)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_FlashNotice),
        _createElementVNode("section", {
          class: _normalizeClass(`AvailableTimeConnectedCalContent lskyblueBg ${_ctx.isSP ? `pad10` : `pad10`} rad8`)
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(`rad8 with_white_bg w100 ${_ctx.isSP ? 'pad10' : 'pad20'}`)
          }, [
            (_ctx.showIconRefreshCal)
              ? (_openBlock(), _createBlock(_component_IconRefresh, {
                  key: 0,
                  tooltipText: `カレンダーを更新`,
                  onRefresh: _ctx.reloadPossibleDates,
                  showTooltip: _ctx.showTooltip,
                  loading: _ctx.loading
                }, null, 8, ["onRefresh", "showTooltip", "loading"]))
              : _createCommentVNode("", true),
            _hoisted_2,
            (_ctx.cm.pdm && _ctx.sliderNum > 0)
              ? _withDirectives((_openBlock(), _createElementBlock("img", {
                  key: 1,
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.prevSlide && _ctx.prevSlide(...args))),
                  class: "pointer posAb z1 prevSlide",
                  width: "49",
                  height: "51",
                  style: {"top":"50%"},
                  src: _ctx.$getAssetImageUrl(`/assets/icons/leftCal.png`)
                }, null, 8, _hoisted_3)), [
                  [
                    _directive_tooltip,
                    `前週`,
                    void 0,
                    { right: true }
                  ]
                ])
              : _createCommentVNode("", true),
            (_ctx.cm.pdm && _ctx.sliderNum < _ctx.MAX_SLIDE_NUM)
              ? _withDirectives((_openBlock(), _createElementBlock("img", {
                  key: 2,
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.nextSlide && _ctx.nextSlide(...args))),
                  class: "pointer posAb z1 nextSlide",
                  width: "49",
                  height: "51",
                  style: {"top":"50%","right":"0"},
                  src: _ctx.$getAssetImageUrl(`/assets/icons/rightCal.png`)
                }, null, 8, _hoisted_4)), [
                  [
                    _directive_tooltip,
                    `翌週`,
                    void 0,
                    { left: true }
                  ]
                ])
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", null, [
                (_ctx.cm.astag)
                  ? (_openBlock(), _createElementBlock("table", _hoisted_6, [
                      _createElementVNode("tr", _hoisted_7, [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList([`日`, `月`, `火`, `水`, `木`, `金`, `土`], (dotw, index) => {
                          return _createVNode(_component_WeeklyDetailHeader, {
                            key: `${dotw}${_ctx.cm.astag.systemUpdatedAt}${index}${_ctx.sliderNum}`,
                            dotw: dotw,
                            today: _ctx.today,
                            date: _ctx.sundayDate.plus({ days: index + _ctx.sliderNum * 7 }),
                            onChangeMonth: _ctx.changeMonth
                          }, null, 8, ["dotw", "today", "date", "onChangeMonth"])
                        }), 64))
                      ]),
                      _hoisted_8
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  id: `WeeklyContent${_ctx.sliderNum}`,
                  class: "WeeklyContent ofs h100",
                  style: {}
                }, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("table", {
                      class: "availableTimeTable w100 posRe",
                      style: _normalizeStyle({
                                        marginLeft: `2%`,
                                        marginTop: `${_ctx.cm.alldayHeight}px`,
                                    })
                    }, [
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.hours, (hour) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: `Hour${hour}${_ctx.systemUpdatedAt}`,
                            class: _normalizeClass(``),
                            style: _normalizeStyle({
                                                height: `${_ctx.Const.CELL_HEIGHT * 4}px`,
                                            })
                          }, [
                            _createElementVNode("td", {
                              class: "posAb fw400 fs11 arial",
                              style: {"margin-top":"-10px"},
                              id: `timeindex${hour}`
                            }, _toDisplayString(hour) + "時 ", 9, _hoisted_11)
                          ], 4))
                        }), 128))
                      ])
                    ], 4)
                  ]),
                  (_ctx.cm.astag && _ctx.isDisplayDailyLine)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList([0, 1, 2, 3, 4, 5, 6], (wday) => {
                          return _createElementVNode("div", {
                            key: `${wday}${_ctx.sliderNum}${_ctx.sundayDate.plus({ days: wday + _ctx.sliderNum * 7 })}`,
                            class: "fl posRe",
                            style: {"width":"14.1%"}
                          }, [
                            _createVNode(_component_DailyLine, {
                              wday: wday,
                              avzones: _ctx.avtimezone[wday],
                              date: _ctx.sundayDate.plus({ days: wday + _ctx.sliderNum * 7 }).startOf(`day`),
                              id: `${_ctx.sliderNum}${wday}`,
                              didConnectCal: _ctx.rm.didConnectCal && _ctx.cm.astag.can_connect_calendar,
                              type: `asview`,
                              onAddEvent: _ctx.addEvent,
                              onUpdateEvent: _ctx.updateEvent,
                              onChangeAvailableEvent: _ctx.changeAvailableEvent,
                              onChangeIgnoreEvent: _ctx.changeIgnoreEvent,
                              onShowEventDetail: _ctx.showEventDetail,
                              onChangeMaxBookingsNum: _ctx.changeMaxBookingsNum
                            }, null, 8, ["wday", "avzones", "date", "id", "didConnectCal", "onAddEvent", "onUpdateEvent", "onChangeAvailableEvent", "onChangeIgnoreEvent", "onShowEventDetail", "onChangeMaxBookingsNum"])
                          ])
                        }), 64))
                      ]))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_9)
              ])
            ])
          ], 2),
          _createVNode(_component_CalendarEventModal, { onCreatedEvent: _ctx.createdEvent }, null, 8, ["onCreatedEvent"]),
          _createVNode(_component_CalendarTagDetailModal, {
            type: _ctx.editCtagType,
            onUpdatedCtag: _ctx.updatedCtag
          }, null, 8, ["type", "onUpdatedCtag"]),
          _createVNode(_component_CalendarEventDetailModal),
          _createVNode(_component_AlertModal, {
            ref: "AlertModal",
            title: _ctx.alertDic?.title,
            text: _ctx.alertDic?.text,
            okButtonName: _ctx.alertDic?.buttonName,
            hideCancelButton: false,
            onClickOK: _ctx.clickOK,
            onClickCancel: _ctx.clickCancel
          }, null, 8, ["title", "text", "okButtonName", "onClickOK", "onClickCancel"]),
          _createVNode(_component_ChangeMaxBookingsNumModal, {
            ev: _ctx.pd,
            onClickOK: _ctx.changedMaxBookingsNum
          }, null, 8, ["ev", "onClickOK"])
        ], 2)
      ]))
    : _createCommentVNode("", true)
}